<template>
	<div class="navigation-container">
		<navigation-drawer/>
	</div>
</template>


<script>
	import Navigation_Drawer from '@/components/ui/Navigation/Navigation_Drawer.vue'

	export default {
		components: {
			'navigation-drawer' : Navigation_Drawer
		}
	}
</script>